export class RecaptchaError extends Error {
  private constructor(message?: string) {
    super(message);
    this.name = 'RecaptchaError';
  }

  static fromError(error: Error): RecaptchaError {
    const instance = new RecaptchaError(error.message);
    instance.stack = error.stack;
    return instance;
  }

  static fromMessage(message: string): RecaptchaError {
    const instance = new RecaptchaError(message);
    instance.stack = new Error().stack;
    return instance;
  }
}
